import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";

const Logout = (): JSX.Element => {
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    const logout = async () => {
      try {
        oktaAuth.tokenManager.clear();
        localStorage.clear();

        await oktaAuth.signOut();
      } catch (error) {
        console.error("Logout failed:", error);
      }
    };

    logout();
  }, [oktaAuth]);

  return <>Signing out...</>;
};

export default Logout;
